import { useEffect } from 'react'
import { ProjectWrapper, LinkButton } from '../../GlobalStyles'
import { ViewAllProjects } from '../../components/ViewAllProjects'
import { Carousel } from '../../components/Carousel'
import { ImageLoader } from '../../components/ImageLoader'
import wave from '../../assets/white-wave.svg'
import mockups from '../../assets/deaflink/deaflink-mockups.jpg'
import image1 from '../../assets/deaflink/deaflink1.png'
import image2 from '../../assets/deaflink/deaflink2.png'
import image3 from '../../assets/deaflink/deaflink3.png'
import image4 from '../../assets/deaflink/deaflink4.png'
import image5 from '../../assets/deaflink/deaflink5.png'
import image6 from '../../assets/deaflink/deaflink6.png'
import image7 from '../../assets/deaflink/deaflink7.png'
import image8 from '../../assets/deaflink/deaflink8.png'
import image9 from '../../assets/deaflink/deaflink9.png'

export const DeafLink = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const projectImages = [
    image1, image2, image3, image4, image5,
    image6, image7, image8, image9,
  ]

  return (
    <ProjectWrapper>
      <div
        className='banner'
        style={{ background: 'linear-gradient(to right, #ACBEFF, #223FA8)' }}
      >
        <img src={wave} alt='decorative wave' />
      </div>

      <section className='description'>
        <h1 className='title'>[ <b>deafLINK</b> ]</h1>
        <div className='summary'>
          <p className='type'>UX Design, Mobile & Web</p>
          <p className='duration'>Solo Project • Oct – Nov 2022</p>
        </div>

        <div className='details'>
          <p>
            deafLINK is a social platform empowering Deaf and hard-of-hearing users to connect  
            through events, resources, and community features. A responsive companion site extends  
            access to hearing users seeking ASL guides, interpreters, and Deaf-friendly services.
          </p>

          <div className='mockups'>
            <ImageLoader src={mockups} alt='deafLINK mockups' borderRadius='10px' />
          </div>

          <p>
            Conducted user research and competitive audits to identify accessibility and engagement gaps,  
            then translated insights into paper sketches, digital wireframes, and interactive prototypes.  
          </p>

          <p>
            Designed a clear information architecture for both mobile and web, prioritizing intuitive  
            navigation and content hierarchy under tight deadlines.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <Carousel images={projectImages} />
        </div>

        <div className='details'>
          <p>
            Delivered a polished UX with high-fidelity Figma prototypes and a streamlined handoff for development. Ensured all interactions met WCAG standards for an inclusive experience.
          </p>
          <div className='buttons'>
            <LinkButton
              className='black'
              href='https://www.figma.com/proto/FHRn3Evf2hBuzznIUb6p1l/deafLINK?node-id=32%3A4&scaling=min-zoom&page-id=32%3A2&starting-point-node-id=32%3A4'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Prototype
            </LinkButton>
            <LinkButton
              className='white'
              href='https://docs.google.com/presentation/d/1ysG7P9TzUwYRyJ-Sni_pDs-ex6HKzDo6VMmUKmbWyY8/edit?usp=sharing'
              target='_blank'
              rel='noopener noreferrer'
            >
              View Case Study
            </LinkButton>
          </div>
        </div>
      </section>
      <ViewAllProjects />
    </ProjectWrapper>
  )
}
